<template>
  <div class="opera-eventWorm">
    <topNav url="/opera/" :title="$t('eventWorm_title')"></topNav>
    <ul class='list'>

      <li v-for="(item,index) in itemList" :key="item.id" class="list_event">
        <mt-cell-swipe :right="[
                    {
                    content: content,
                    style: {background: 'red', color: '#fff',lineHeight:'3.8933rem' },
                    handler:function(){deleteEv(item,index)}
                    }
                ]">
          <div slot="title">
            <h1>
              <span @click="link(item.id)">{{$t('eventWorm_descript')}}：{{item.descript}}</span>
              <mt-switch v-model="item.isHalt" @change='switchEvent(item)'></mt-switch>
            </h1>

            <div class="wormContent" @click="link(item.id)">
              <div>
                <p>{{$t('eventWorm_day_conditions')}}：<span v-if="item.daySpan=='0~0'">{{$t('eventWorm_today')}}</span><span
                  v-else> {{$t('eventWorm_advance')}} {{item.daySpan}} {{$t('eventWorm_day')}}</span></p>
                <p>{{$t('eventWorm_triggering_time')}}：{{item.pushmsgDatetime.toString()}}</p>
                <p>{{$t('eventWorm_conditions')}}:{{item.triggerConditionString}}</p>
                <p>{{$t('eventWorm_notice_content')}}：{{item.noticeContent}}</p>
              </div>

              <div class="rightTou">
                <i class="iconfont icon-you1"></i>
              </div>
            </div>

          </div>
        </mt-cell-swipe>
      </li>
    </ul>
    <nothing :condition="itemList != null && itemList.length == 0"></nothing>
    <div class="addevent" @click='goAdd'>
      <i class="iconfont icon-jia"></i>
    </div>
  </div>
</template>

<script>
  import {Toast} from "mint-ui";
  import nothing from "../operaCommon/nothing";

  export default {
    data() {
      return {
        itemList: null
      };
    },
    computed: {
      content() {
        return this.$t("delete");
      },
      Toast_nomorethan5() {
        return this.$t("Toast_nomorethan5");
      }
    },
    mounted() {
      this.$http
        .post("/mobilepmsapi/message/searchMessageTrigger")
        .then(res => {
          //console.log(res.data.retVal)
          _.forEach(res.data.retVal, function (n, key) {
            n["isHalt"] = n["isHalt"] == "T" ? false : true;
          });
          this.itemList = res.data.retVal;
        });
    },
    methods: {
      switchEvent(item) {
        this.$http.post(
          "/mobilepmsapi/message/messageTriggerToggle/" + item.id + ""
        );
      },
      link(id) {
        var url = "/opera/eventInfo?id=" + id;
        if (this.$route.query.redirect != null) {
          url +=
            "&redirect=" +
            encodeURI("/opera/eventWorm?redirect=" + this.$route.query.redirect);
        }
        this.$router.push(url);
      },
      goAdd() {
        if (this.itemList.length >= 5) {
          Toast(this.Toast_nomorethan5);
          return;
        }
        this.$router.push("/opera/addNewEvent");
      },
      deleteEv(item, index) {
        // window.event? window.event.cancelBubble = true : e.stopPropagation();
        this.$http
          .delete("/mobilepmsapi/message/messageTrigger/" + item.id)
          .then(res => {
            if (res.data.result == 0) {
              this.itemList.splice(index, 1);
              Toast(this.$t('msg_delete_success'));
            }
          });
      }
    },
    components: {
      nothing
    }
  };
</script>
<style lang='less'>
  .opera-eventWorm {
    background: #f6f8f9;

    .addevent {
      position: absolute;
      bottom: 20px;
      right: 40px;
      width: 45px;
      height: 46px;
      border-radius: 50%;
      background: #ff8000;
      color: #fff;
      line-height: 53px;
      text-align: center;
      z-index: 10;

      .iconfont {
        line-height: 45px;
        font-size: 20px;
      }
    }

    .list {
      margin: 0 10px;

      li {
        background: #fff;
        overflow: hidden;
        border-top: 3px solid #ccc;
        margin-top: 10px;
        // padding: 0 10px;
        position: relative;

        .mint-cell-right {
          right: -1px;
        }

        h1 {
          border-bottom: 1px dashed #ccc;
          // padding: 5px 0;
          display: flex;
          justify-content: space-between;

          span {
            line-height: 1rem;
          }

          .mint-switch {
            transform: scale(0.6);

            .mint-switch-input:checked + .mint-switch-core {
              background-color: #35b34a;
              border-color: #35b34a;
            }
          }
        }

        .wormContent {
          margin: 10px 0;
          position: relative;

          .rightTou {
            margin-right: 10px;
            position: absolute;
            top: 40%;
            right: 0px;
            color: #999;
            transform: scale(1.3, 1.7);
            font-size: 0.7rem;
          }

          .rightTou .i {
            font-size: 0.7rem;
          }

          p {
            padding: 5px 0;
          }

          .delete {
            width: 100px;
            float: right;
            line-height: 20px;
            font-size: 14px;
            color: red;
          }
        }

        a {
          color: #333;
        }
      }

      .mint-cell-wrapper {
        font-size: inherit;
      }

      .mint-cell-wrapper {
        background-image: none;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// eventWorm.vue?6b024312